export const tutorialStepResourceType = "tutorial_step" as const;
export const handbookResourceType = "handbook" as const;
export const tutorialStepValidationPath = "validate/tutorial_step" as const;
